import React, { useState } from "react";
import PropTypes from "prop-types";

import ListarDatos from "../../general/ListarDatos";
import { BtnPermiso } from "../../general/BotonesAccion";
import BotonAtras from "../components/BotonAtras";
import { Cargando, EstadoVacio } from "../components/Estados";
import ModalPermisos from "./ModalPermisos";

import { useConsulta } from "../hooks/useConsulta";
import { obtenerGestores } from "../services/bibliotecaApi";

/** "Libro a tu clase: 3 estados" por cada tipo asignado. */
const resumenPermisos = (permisos, tipos) => {
  const partes = tipos
    .filter(({ codigo }) => codigo in permisos)
    .map(({ codigo, nombre }) => {
      const cantidad = permisos[codigo].length;
      return `${nombre}: ${cantidad} ${cantidad === 1 ? "estado" : "estados"}`;
    });
  return partes.length ? partes.join(" · ") : "Sin permisos asignados";
};

/**
 * Controlar Permisos, como en Gestion Practicas: las personas con perfil de
 * administrador o auxiliar de biblioteca, y que tipos y estados gestiona cada
 * una. El perfil se les pone desde Personas; aqui solo se asignan permisos.
 */
const PermisosGestores = ({ onMensaje, volver }) => {
  const [version, setVersion] = useState(0);
  const { datos, cargando, error } = useConsulta(obtenerGestores, [version], null);
  const [editando, setEditando] = useState(null);

  const contenido = () => {
    if (cargando && !datos) return <Cargando />;
    if (error || !datos) {
      return <EstadoVacio mensaje={error?.message ?? "No fue posible cargar las personas"} />;
    }
    if (datos.gestores.length === 0) {
      return (
        <EstadoVacio mensaje="Nadie tiene perfil de biblioteca. Asigna ADMINISTRADOR BIBLIOTECA o AUXILIAR BIBLIOTECA desde Personas." />
      );
    }

    return (
      <ListarDatos
        id="tbl_biblioteca_gestores"
        datos={datos.gestores}
        titulo="Personas de biblioteca"
        opciones
        buscar
        refrescar
        actRefrescar={() => setVersion((actual) => actual + 1)}
        avatar={({ nombre }) => nombre?.charAt(0).toUpperCase()}
        fila_principal={({ nombre }) => nombre.toUpperCase()}
        filas={[
          { id: "perfil", mostrar: ({ perfil }) => perfil?.nombre },
          { id: "correo" },
          {
            id: "permisos",
            mostrar: ({ permisos }) => resumenPermisos(permisos, datos.tipos),
          },
        ]}
        acciones={(gestor) => <BtnPermiso callback={() => setEditando(gestor)} />}
      />
    );
  };

  return (
    <div>
      <BotonAtras onClick={volver} />
      {contenido()}
      {editando && datos && (
        <ModalPermisos
          gestor={editando}
          tipos={datos.tipos}
          onMensaje={onMensaje}
          onCerrar={() => setEditando(null)}
          onGuardado={() => {
            setEditando(null);
            setVersion((actual) => actual + 1);
          }}
        />
      )}
    </div>
  );
};

PermisosGestores.propTypes = {
  onMensaje: PropTypes.func.isRequired,
  volver: PropTypes.func.isRequired,
};

export default PermisosGestores;
